import { mapMethods } from './api'

const ENDPOINT = 'roles'

export const key = 'name'

export default {
    ...mapMethods(ENDPOINT, [
        'search',
        'delete',
        'update',
        'create',
        'view'
    ])
}
